var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCameraDisabled = function SvgCameraDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.64 1.008 8.86 8.86-.633.632-1.594-1.594A.575.575 0 0 1 7.992 9h-6a.48.48 0 0 1-.492-.492V3.492A.48.48 0 0 1 1.992 3h.375l-1.36-1.36.634-.632Zm8.86 2.25v5.344L4.898 3h3.094a.5.5 0 0 1 .516.492V5.25L10.5 3.258Z",
    fill: "#fff"
  })));
};
export default SvgCameraDisabled;